<template>
  <div class="landingpage_wrapper">
    <home-header></home-header>
    <home-section-navigation
      :active-section="activeSection"
    ></home-section-navigation>
    <home-sections :active-section.sync="activeSection"></home-sections>
  </div>
</template>

<script>
import homeHeader from './homeHeader';
import HomeSectionNavigation from './homeSectionNavigation';
import HomeSections from './homeSections';

export default {
  name: 'Home',
  components: {
    homeHeader,
    HomeSectionNavigation,
    HomeSections,
  },
  data() {
    return {
      activeSection: null,
    };
  },
};
</script>
